import { PPDialog } from 'components/PPDialog'
import styles from './MobileWarningDialog.pcss'

export function MobileWarningDialog(props: {
  title?: string,
  message?: string
}) {
  const title = 'Post Planner is not available on mobile browsers. Please install our mobile app.'
  const subtitle = 'If you\'re on a tablet or iPad, please turn your device sideways (landscape) to use the app here in the browser.'

  return (
    <PPDialog open dismissible={false} size="lg" title={props.title || title}>
      <div className={styles.dialog}>
        <div className={styles.actions}>
          <a
            href="https://apps.apple.com/app/apple-store/id1573125897"
            rel="noopener"
            target="_blank"
            className={styles['img-link']}
          >
            <img src="/static/img/misc/ios-350px.png" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.postplanner.app"
            rel="noopener"
            target="_blank"
            className={styles['img-link']}
          >
            <img src="/static/img/misc/play-350px.png" />
          </a>
        </div>
        <div className={styles.subtitle}>
          {props.message || subtitle}
        </div>
      </div>
    </PPDialog>
  )
}

export default MobileWarningDialog
